import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // 'instant' overrides the global `scroll-behavior: smooth`: a smooth scroll
    // started while the new page is still loading gets interrupted when its
    // content arrives (or by a touch on mobile), leaving the reader at the
    // bottom of the page they came from.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // dashboard/admin layouts scroll an inner <main>, not the window
    document.querySelector('[data-scroll-root]')?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
